import { useState } from "react";
import "./App.scss";
import { Navbar } from "./components";
import { About, Footer, Hero, Portfolio, Skills } from "./container";

function App() {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleActiveIndex = (idx) => {
    setActiveIndex(idx)
  }

  return (
    <main className="mainpage">
      <Navbar activeIndex={activeIndex}/>
      <Hero handleActiveIndex={handleActiveIndex} />
      <About handleActiveIndex={handleActiveIndex} />
      <Portfolio handleActiveIndex={handleActiveIndex} />
      <Skills handleActiveIndex={handleActiveIndex} />
      <Footer handleActiveIndex={handleActiveIndex} />
    </main>
  );
}

export default App;
